import { z } from 'zod';
import { getUniqueTrustedPlatforms, } from './platform-registry';
export const trustedExtensionPlatformSchema = z.enum([
    'all',
    ...getUniqueTrustedPlatforms(),
]);
/**
 * Trusted Extension - returned from API
 *
 * This represents a global trusted list entry that prevents
 * specific extensions from being auto-removed.
 */
export const trustedExtensionSchema = z.object({
    id: z.string().uuid(),
    extensionId: z.string(),
    platform: trustedExtensionPlatformSchema,
    reason: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
/**
 * List of trusted extensions
 */
export const trustedExtensionsListSchema = z.object({
    extensions: z.array(trustedExtensionSchema),
});
/**
 * Add trusted extension - request body
 */
export const addTrustedExtensionBodySchema = z.object({
    extensionId: z.string().min(1),
    platform: trustedExtensionPlatformSchema,
    reason: z.string().optional(),
});
/**
 * Add trusted extension - response
 */
export const addTrustedExtensionResponseSchema = trustedExtensionSchema;
//# sourceMappingURL=trusted-extensions.js.map